module.exports = __webpack_public_path__ + "static/media/DBKFoundryEXTA0005b_design_clean_v001.b0d4f41a.webp";